(() => {
  const main = document.getElementById('main');
  if (!main) return;
  const roots = '.vl-product .accordion__content.prose, .vl-page-content__body, .vl-content-page .prose';
  const meaningful = 'img, picture, video, audio, iframe, svg, canvas, object, embed, input, button, table, a[href], a[name], [id], [role]';
  // The exact authorised draft emits this attribute; merchant-authored content
  // stays intact in Admin while its internal links retain the preview/locale.
  const contentRoot = main.getAttribute('data-raith-content-root');
  const internalHosts = new Set(['raith-clo.com', 'www.raith-clo.com', 'raithclothing.myshopify.com']);
  const nativePaths = /^\/(?:products|collections|pages|blogs|policies|search|apps|account|cart)(?:\/|$)/;
  const returnsPath = /^\/(?:[a-z]{2,3}(?:-[a-z0-9]{2,8})*\/)?pages\/returns(?:-us)?\/?$/;
  const returnsTarget = main.getAttribute('data-raith-returns-url')?.trim();
  const returnsURL = returnsPath.test(returnsTarget || '') ? returnsTarget : null;
  const normalizeLink = link => {
    if (contentRoot === null) return;
    const raw = link.getAttribute('href')?.trim();
    if (!raw || /^[?#]/.test(raw) || /[\\\u0000-\u001f\u007f]/.test(raw)) return;
    const absolute = /^(?:https?:)?\/\//i.test(raw);
    // URL parsing removes explicit default ports, so inspect the authored authority too.
    const authority = absolute ? raw.match(/^(?:https?:)?\/\/([^/?#]*)/i)?.[1] : null;
    if (authority !== null && (!authority || /[:@]/.test(authority))) return;
    try {
      const url = new URL(raw, location.href);
      if (!/^https?:$/.test(url.protocol) || url.port || url.username || url.password) return;
      if (returnsURL && returnsPath.test(url.pathname) &&
          (url.origin === location.origin || internalHosts.has(url.hostname) || url.hostname === 'nl.raith-clo.com')) {
        const destination = returnsURL + url.search + url.hash;
        if (link.getAttribute('href') !== destination) link.setAttribute('href', destination);
        return;
      }
      if (!absolute || !internalHosts.has(url.hostname)) return;
      const root = `${contentRoot.replace(/\/$/, '')}/`;
      const path = nativePaths.test(url.pathname) || url.pathname === '/' ? root + url.pathname.slice(1) : url.pathname;
      const destination = path + url.search + url.hash;
      if (link.getAttribute('href') !== destination) link.setAttribute('href', destination);
    } catch { /* Leave malformed authored URLs untouched. */ }
  };
  const normalize = scope => {
    const regions = [...scope.querySelectorAll(roots)];
    if (scope.matches?.(roots)) regions.unshift(scope);
    for (const region of regions) {
      region.querySelectorAll('a[href]').forEach(normalizeLink);
      for (const paragraph of region.querySelectorAll('p')) {
        const empty = !paragraph.textContent.replace(/[\s\u00a0\u200b]/g, '') && !paragraph.matches('[id], [role]') && !paragraph.querySelector(meaningful);
        paragraph.toggleAttribute('data-raith-empty-text', empty);
      }
    }
  };
  normalize(main);
  new MutationObserver(records => {
    const scopes = new Set();
    for (const record of records) {
      const region = record.target.nodeType === 1 ? record.target.closest(roots) : record.target.parentElement?.closest(roots);
      if (region) scopes.add(region);
      for (const node of record.addedNodes) if (node.nodeType === 1) scopes.add(node);
    }
    scopes.forEach(normalize);
  }).observe(main, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['id', 'role', 'href', 'name']});
})();
